import MUIDrawer from '@mui/material/Drawer'
import { styled, Theme } from '@mui/material/styles'

import {
  drawerMiniWidth,
  drawerWidth,
  transitionDuration,
} from '../../store/constant'

function openedMixin(theme: Theme): Record<string, unknown> {
  return {
    width: drawerWidth,
    borderRight: 'none',
    zIndex: 1099,
    overflowX: 'hidden',
    boxShadow: 'none',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen + transitionDuration,
    }),
  }
}

function closedMixin(theme: Theme): Record<string, unknown> {
  return {
    borderRight: 'none',
    zIndex: 1099,
    overflowX: 'hidden',
    width: drawerMiniWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen + transitionDuration,
    }),
  }
}

interface DrawerProps {
  drawerOpen: boolean
}

function getStyles({
  theme,
  drawerOpen,
}: {
  theme: Theme
  drawerOpen: boolean
}) {
  return {
    width: drawerWidth,
    borderRight: '0px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    '& .MuiDrawer-paper': drawerOpen ? openedMixin(theme) : closedMixin(theme),
  }
}

const Drawer = styled(MUIDrawer, {
  shouldForwardProp: (prop: string) => prop !== 'drawerOpen',
})<DrawerProps>(getStyles)

export default Drawer
